//
// generated by bin/gen_paths
//

type P = string | number;

export default {
  // alerts
  alerts_alert: (id: P) => `/alerts/${id}`, // get
  alerts_backfill: (id: P, job_id: P) => `/alerts/${id}/b/${job_id}`, // get
  alerts_create: "/create", // get|post
  alerts_destroy: (id: P) => `/destroy/${id}`, // delete
  alerts_preview: (id?: P) => `/preview${isNotNil(id) ? ('/' + id) : ''}`, // get|post
  alerts_update: (id: P) => `/edit/${id}`, // get|patch

  // auth
  auth_forgot: "/forgot", // get|post
  auth_join: (id: P) => `/join/${id}`, // get
  auth_login: "/login", // get|post
  auth_logout: "/logout", // post
  auth_oauth: (provider: P) => `/oauth/${provider}`, // get
  auth_reset: "/reset", // get|post
  auth_signup: "/signup", // get|post

  // billing
  billing: "/billing", // get
  billing_cancel: "/billing/cancel", // delete
  billing_pricing: "/pricing", // get|post
  billing_renew: "/billing/renew", // get|post
  billing_stripe_cancel_complete: "/billing/stripe_cancel_complete", // get
  billing_stripe_checkout_complete: "/billing/stripe_checkout_complete", // get
  billing_update_payment: "/billing/update_payment", // post

  // charts
  charts_alert_chart: (alert_id: P) => `/charts/alerts/${alert_id}.png`, // get

  // click
  click: "/c", // get

  // dash
  dash: "/dashboard", // get

  // home
  home_about: "/about", // get
  home_careers: "/careers", // get
  home_faq: "/faq", // get
  home_privacy: "/privacy", // get
  home_root: "/", // get
  home_tos: "/tos", // get

  // lists
  lists_destroy: (id: P) => `/lists/destroy/${id}`, // delete
  lists_list: (id: P, slug: P) => `/lists/${id}/${slug}`, // get

  // onboarding
  onboarding_create_alert: "/o/alert", // get|post
  onboarding_pick: "/o/pick", // get|post
  onboarding_plans: "/o/plans", // get|post
  onboarding_preview_alert: "/o/preview", // get|post
  onboarding_quiz: "/o/quiz", // get|post
  onboarding_stripe_checkout_complete: "/o/stripe_checkout_complete", // get
  onboarding_verify: "/o/verify", // get|post

  // settings
  settings: "/settings", // get|post

  // api/alerts
  api_alerts_block_preview: (id: P) => `/api/alerts/${id}/block_preview`, // post
  api_alerts_toggle_watched: (id: P) => `/api/alerts/${id}/toggle_watched`, // post
  api_alerts_update: (id: P) => `/api/alerts/${id}`, // patch

  // api/auth
  api_auth_verify_resend: "/api/auth/verify_resend", // post

  // api/jobs
  api_jobs_show: (id: P) => `/api/jobs/${id}`, // get

  // api/lists
  api_lists_create: "/api/lists", // post
  api_lists_update: (id: P) => `/api/lists/${id}`, // patch

  // api/mentions
  api_mentions_update: (id: P) => `/api/mentions/${id}`, // patch
  api_mentions_block: (id: P) => `/api/mentions/${id}/block`, // post

  // api/team
  api_team_create_invite_link: "/api/team/create_invite_link", // post
  api_team_remove_user: "/api/team/remove_user", // delete
  api_team_update: "/api/team", // patch
};
